import { fields } from ".";
import { change, Field, reduxForm } from "redux-form";
import Button from "components/atoms/Button";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import DeviceDetectService from "services/deviceDetect.service";
import { email, required, requiredArray } from "utils/validate.util";
import InputRedux from "components/molecules/InputRedux";
import { Box, Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { useEffect } from "react";
import SelectAutoCompleteBookings from "components/organisms/SelectAutoCompleteBookings";
import StatusCard from "components/templates/StatusCard";
import PaymentLinkService from "services/paymentLink.service";
import { paymentLinkActions } from "redux/slices/paymentLink";
import CircularProgress from "components/atoms/CircularProgress";

function UpdatePaymentLinkForm({ handleSubmit }: any) {
  let form = "UpdatePaymentLinkForm";
  const userAgent: string = navigator.userAgent || navigator.vendor;
  const isMobile = DeviceDetectService.isMobileDevice(userAgent);
  const dispatch = useAppDispatch();
  const paymentLink = useAppSelector((state) => state.paymentLink.paymentLink);
  const modelData = useAppSelector((state) => state.modal.data);
  const paymentLoader = useAppSelector((state) => state.paymentLink.loading);

  useEffect(() => {
    PaymentLinkService.getPaymentLink(`${modelData?.PayentLinkId}`);
    return () => {
      dispatch(paymentLinkActions.setPaymentLink(null));
    };
  }, [modelData?.PayentLinkId, dispatch]);

  useEffect(() => {
    if (!paymentLink || Object.keys(paymentLink).length === 0) return;
    const { email, price, trip_ids, trip_id, link, note } = paymentLink;
    dispatch(change(form, "price", price));
    const mappedTripIds = trip_ids?.map((trip: any) => ({
      value: trip?._id,
      label: "Booking# " + trip?.booking_number,
      name: `${trip?.booking_for_details?.first_name || ""} ${
        trip?.booking_for_details?.last_name || ""
      }`.trim(),
    }));
    const tripIds =
      mappedTripIds?.length > 0
        ? mappedTripIds
        : trip_id?._id
          ? [
              {
                value: trip_id?._id,
                label: "Booking# " + trip_id?.booking_number,
                name: `${trip_id?.booking_for_details?.first_name || ""} ${
                  trip_id?.booking_for_details?.last_name || ""
                }`.trim(),
              },
            ]
          : [];
    dispatch(change(form, "trip_ids", tripIds));
    dispatch(change(form, "link", link));
    dispatch(change(form, "email", email));
    dispatch(change(form, "note", note));
  }, [paymentLink, dispatch, form]);

  return (
    <Box sx={{ position: "relative" }}>
      {paymentLoader && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(255,255,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
            borderRadius: 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={fields()} />
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={6}>
            <Field
              name="email"
              label="Email"
              component={InputRedux}
              validate={[required, email]}
            />
          </Grid>
          <Grid item xs={12} sm={8} md={6}>
            <Field
              name={"trip_ids"}
              label={"Yelo Bookings"}
              isMobile={isMobile}
              keyboard={true}
              component={SelectAutoCompleteBookings}
              form="UpdatePaymentLinkForm"
              validate={[requiredArray]}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={12}>
            <Field
              name={"note"}
              label={"Notes"}
              component={InputRedux}
              InputProps={{ multiline: true, rows: 5 }}
            />
          </Grid>
        </Grid>
        <br />
        <Button variant="contained" type="submit">
          Submit
        </Button>

        <StatusCard
          data={paymentLink}
          height={250}
          headingStyle={{ fontSize: "1.17em" }}
          isZonedTime={true}
        />
      </form>
    </Box>
  );
}
export default reduxForm({ form: "UpdatePaymentLinkForm" })(
  UpdatePaymentLinkForm
);
